/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.easyhub.ai/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.easyhub.ai)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Home from "./views/pages/home/HomeDark";
import Deals from "./views/pages/deals/Deals";
import DealDetail from "./views/pages/deal/DealDetail";
import ServiceDetail from "./views/pages/service/ServiceDetail";
import Profile from "./views/pages/profile/Profile";
import Wifi from "./views/pages/wifi/Wifi";
import Access from "./views/pages/access/Access";
import Stay from "./views/pages/stay/Stay";
import Upgrades from "./views/pages/upgrades/Upgrades";
import Guides from "./views/pages/guides/Guides";

const routes = [
  {
    collapse: false,
    name: "Home",
    icon: "ni ni-shop text-primary",
    path: "/home",
    miniName: "H",
    component: <Home />,
    layout: "/admin",
    views: []
  },
  {
    collapse: false,
    name: "Deals",
    icon: "ni ni-tag text-primary",
    path: "/deals",
    miniName: "D",
    component: <Deals />,
    layout: "/admin",
    views: []
  },
  {
    collapse: false,
    name: "Deal Detail",
    icon: "ni ni-tag text-primary",
    path: "/deal/:dealId",
    miniName: "DD",
    component: <DealDetail />,
    layout: "/admin",
    visible: false,
    views: []
  },
  {
    collapse: false,
    name: "Service Detail",
    icon: "ni ni-diamond text-primary",
    path: "/service/:serviceCode",
    miniName: "SD",
    component: <ServiceDetail />,
    layout: "/admin",
    visible: false,
    views: []
  },
  {
    collapse: false,
    name: "Profile",
    icon: "ni ni-single-02 text-primary",
    path: "/profile",
    miniName: "P",
    component: <Profile />,
    layout: "/admin",
    views: []
  },
  {
    collapse: false,
    name: "Access",
    icon: "ni ni-key-25 text-primary",
    path: "/access",
    miniName: "A",
    component: <Access />,
    layout: "/admin",
    views: []
  },
  {
    collapse: false,
    name: "WiFi",
    icon: "ni ni-world text-primary",
    path: "/wifi",
    miniName: "W",
    component: <Wifi />,
    layout: "/admin",
    views: []
  },
  {
    collapse: false,
    name: "Stay",
    icon: "ni ni-calendar-grid-58 text-primary",
    path: "/stay",
    miniName: "S",
    component: <Stay />,
    layout: "/admin",
    views: []
  },
  {
    collapse: false,
    name: "Upgrades",
    icon: "ni ni-diamond text-primary",
    path: "/upgrades",
    miniName: "U",
    component: <Upgrades />,
    layout: "/admin",
    views: []
  },
  {
    collapse: false,
    name: "Guides",
    icon: "ni ni-book-bookmark text-primary",
    path: "/guides",
    miniName: "G",
    component: <Guides />,
    layout: "/admin",
    views: []
  }
];

export default routes;
